import React, { useEffect, useState } from 'react';
import { Button, Card, Pagination } from 'antd';
import { errorSwal } from '../../../helper/swalHelpers';

import clienteAxios from '../../../configAxios/configAxios';
import { Col, Row } from 'react-bootstrap';
import { DownloadOutlined } from '@ant-design/icons';
import './garantia.css'


const Sos = () => {
    
    const [secciones, setSecciones] = useState([]);
    const [seccionesFilter, setSeccionesFilter] = useState([]);

    useEffect(() => {
        const fetchDataSos = async () => {
            try {
                let response = await clienteAxios.get('BuscarSeccionActivoPorModulo/SERV_TECNICO');
                if (response.status === 200) {
                    let data = response.data.data;
                    setSecciones(data);                    
                    setSeccionesFilter(data.slice(0, 3))
                }
            } catch (error) {
                errorSwal("Ocurrió un error", "Vuelve a intentarlo", "Refrescar pagina");
            }
        };
        fetchDataSos();

    }, [])

    const seccionesPorPagina = 3;

    const totalSecciones = secciones && secciones.length > 0 && secciones.length;

    const onChange = (page) => {
        setSeccionesFilter(secciones.slice((page - 1) * seccionesPorPagina, page * seccionesPorPagina));
    }

    if (!secciones || secciones.length < 1) return null;

    return (
        <>
            <Row>
                <Col xs={12} className="text-right d-none d-md-block">
                    <Pagination className="paginador-hyundai" defaultCurrent={1} defaultPageSize={seccionesPorPagina} total={totalSecciones} onChange={onChange} />
                </Col>
            </Row>
            <Row className="mt-5 d-none d-md-flex ">
                {seccionesFilter && seccionesFilter.length > 0 &&
                    seccionesFilter.map((seccion, i) =>
                        <Col xs={12} md={6} lg={4} key={i} className="mx-auto px-lg-4 border-clientes mb-3 ">
                            <Card bordered={false} cover={<img alt={seccion.Titulo} src={seccion.Imagen} className="img-fluid img-exp-clientes" />}  >
                                <Card.Meta title={<Titulo titulo={seccion.Titulo} />} description={<Descripcion descripcion={seccion.Contenido} descargable={seccion.ImagenDestacada} />} />
                            </Card>
                        </Col>
                    )
                }
            </Row>
            <Row className="mt-4 d-md-none px-4">
                {secciones && secciones.length > 0 &&
                    secciones.map((seccion, i) =>
                        <Col xs={12} md={6} lg={4} key={i} className="px-lg-4 border-clientes mb-3">
                            <Card bordered={false} cover={<img alt={seccion.Titulo} src={seccion.Imagen} className="img-fluid img-exp-clientes" />}  >
                                <Card.Meta title={<Titulo titulo={seccion.Titulo} />} description={<Descripcion descripcion={seccion.Contenido} descargable={seccion.ImagenDestacada} />} />
                            </Card>
                        </Col>
                    )
                }
            </Row>
        </>
    );
};

const Titulo = ({ titulo, descargable }) => {
    if (!titulo) return null;
    return (
        <Row>
            <Col><h5 className="bold-title-hyundai mb-0 f-responsive">{titulo}</h5></Col>
            {/* <Col xs={4} className="text-right f-responsive-10">
                <Button className='btn-secundario-ficha w-100 font-btn btn-descargar-caracteristicas' href={descargable} target='_blank' style={{ borderRadius: '4px !important' }} icon={<DownloadOutlined />}>
                    Descargar
                </Button>
            </Col> */}
        </Row>
    )
}

const Descripcion = ({ descripcion, descargable }) => {
    if (!descripcion) return null;

    return (
        <Row>
            <Col xs={12}>
                <p className="parrafo-hyundai text-dark mb-0 f-responsive-10" dangerouslySetInnerHTML={{ __html: descripcion}}></p>
            </Col>
            {descargable &&
            <Col xs={"auto"} className="text-center my-4 f-responsive-10">
                <Button className='btn-secundario-ficha w-100 font-btn btn-descargar-caracteristicas' href={descargable} target='_blank' style={{ borderRadius: '4px !important' }} icon={<DownloadOutlined />}>
                    Descargar
                </Button>
            </Col>
            }
        </Row>
    )

}

export default Sos;